export const countryName = {
  AF: { id: 1, primary: "AF", secondary: "+93" },
  AE: { id: 2, primary: "AE", secondary: "+971" },
  AF: { id: 3, primary: "AF", secondary: "+93" },
  AG: { id: 4, primary: "AG", secondary: "+1-268" },
  AI: { id: 5, primary: "AI", secondary: "+1-264" },
  AL: { id: 6, primary: "AL", secondary: "+355" },
  AM: { id: 7, primary: "AM", secondary: "+374" },
  AO: { id: 8, primary: "AO", secondary: "+244" },
  AQ: { id: 9, primary: "AQ", secondary: "+672" },
  AR: { id: 10, primary: "AR", secondary: "+54" },
  AS: { id: 11, primary: "AS", secondary: "+1" },
  AT: { id: 12, primary: "AT", secondary: "+43" },
  AU: { id: 13, primary: "AU", secondary: "+61" },
  AW: { id: 14, primary: "AW", secondary: "+297" },
  AX: { id: 15, primary: "AX", secondary: "+358" },
  AZ: { id: 16, primary: "AZ", secondary: "+994" },
  BA: { id: 17, primary: "BA", secondary: "+387" },
  BB: { id: 18, primary: "BB", secondary: "+1" },
  BD: { id: 19, primary: "BD", secondary: "+880" },
  BE: { id: 20, primary: "BE", secondary: "+32" },
  BF: { id: 21, primary: "BF", secondary: "+226" },
  BG: { id: 22, primary: "BG", secondary: "+359" },
  BH: { id: 23, primary: "BH", secondary: "+973" },
  BI: { id: 24, primary: "BI", secondary: "+257" },
  BJ: { id: 25, primary: "BJ", secondary: "+229" },
  BL: { id: 26, primary: "BL", secondary: "+590" },
  BM: { id: 27, primary: "BM", secondary: "+1" },
  BN: { id: 28, primary: "BN", secondary: "+673" },
  BO: { primary: "BO", secondary: "+591", id: 29 },
  BQ: { primary: "BQ", secondary: "+599", id: 30 },
  BR: { primary: "BR", secondary: "+55", id: 31 },
  BS: { primary: "BS", secondary: "+1", id: 32 },
  BT: { primary: "BT", secondary: "+975", id: 33 },
  BW: { primary: "BW", secondary: "+267", id: 34 },
  BY: { primary: "BY", secondary: "+375", id: 35 },
  BZ: { primary: "BZ", secondary: "+501", id: 36 },
  CA: { primary: "CA", secondary: "+1", id: 37 },
  CC: { primary: "CC", secondary: "+61", id: 38 },
  CD: { primary: "CD", secondary: "+243", id: 39 },
  CF: { primary: "CF", secondary: "+236", id: 40 },
  CG: { primary: "CG", secondary: "+242", id: 41 },
  CH: { primary: "CH", secondary: "+41", id: 42 },
  CI: { primary: "CI", secondary: "+225", id: 43 },
  CK: { primary: "CK", secondary: "+682", id: 44 },
  CL: { primary: "CL", secondary: "+56", id: 45 },
  CM: { primary: "CM", secondary: "+237", id: 46 },
  CN: { primary: "CN", secondary: "+86", id: 47 },
  CO: { id: 48, primary: "CO", secondary: "+57" },
  CR: { id: 49, primary: "CR", secondary: "+506" },
  CU: { id: 50, primary: "CU", secondary: "+53" },
  CV: { id: 51, primary: "CV", secondary: "+238" },
  CW: { id: 52, primary: "CW", secondary: "+599" },
  CX: { id: 53, primary: "CX", secondary: "+61" },
  CY: { id: 54, primary: "CY", secondary: "+357" },
  CZ: { id: 55, primary: "CZ", secondary: "+420" },
  DE: { id: 56, primary: "DE", secondary: "+49" },
  DJ: { id: 57, primary: "DJ", secondary: "+253" },
  DK: { id: 58, primary: "DK", secondary: "+45" },
  DM: { id: 59, primary: "DM", secondary: "+1" },
  DO: { id: 60, primary: "DO", secondary: "+1" },
  DZ: { id: 61, primary: "DZ", secondary: "+213" },
  EC: { id: 62, primary: "EC", secondary: "+593" },
  EE: { id: 63, primary: "EE", secondary: "+372" },
  EG: { id: 64, primary: "EG", secondary: "+20" },
  ER: { id: 65, primary: "ER", secondary: "+291" },
  ES: { id: 66, primary: "ES", secondary: "+34" },
  ET: { id: 67, primary: "ET", secondary: "+251" },
  FI: { id: 68, primary: "FI", secondary: "+358" },
  FJ: { id: 69, primary: "FJ", secondary: "+679" },
  FK: { id: 70, primary: "FK", secondary: "+500" },
  FM: { id: 71, primary: "FM", secondary: "+691" },
  FO: { id: 72, primary: "FO", secondary: "+298" },
  FR: { id: 73, primary: "FR", secondary: "+33" },
  GA: { id: 74, primary: "GA", secondary: "+241" },
  GB: { id: 75, primary: "GB", secondary: "+44" },
  GD: { id: 76, primary: "GD", secondary: "+1473" },
  GE: { id: 77, primary: "GE", secondary: "+995" },
  GF: { id: 78, primary: "GF", secondary: "+594" },
  GG: { id: 79, primary: "GG", secondary: "+44" },
  GH: { id: 80, primary: "GH", secondary: "+233" },
  GI: { id: 81, primary: "GI", secondary: "+350" },
  GL: { id: 82, primary: "GL", secondary: "+299" },
  GM: { id: 83, primary: "GM", secondary: "+220" },
  GN: { id: 84, primary: "GN", secondary: "+224" },
  GP: { primary: "GP", secondary: "+590", id: 85 },
  GQ: { primary: "GQ", secondary: "+240", id: 86 },
  GR: { primary: "GR", secondary: "+30", id: 87 },
  GS: { primary: "GS", secondary: "+500", id: 88 },
  GT: { primary: "GT", secondary: "+502", id: 89 },
  GU: { primary: "GU", secondary: "+1-671", id: 90 },
  GW: { primary: "GW", secondary: "+245", id: 91 },
  GY: { primary: "GY", secondary: "+592", id: 92 },
  HK: { primary: "HK", secondary: "+852", id: 93 },
  HN: { primary: "HN", secondary: "+504", id: 94 },
  HR: { primary: "HR", secondary: "+385", id: 95 },
  HT: { primary: "HT", secondary: "+509", id: 96 },
  HU: { primary: "HU", secondary: "+36", id: 97 },
  ID: { primary: "ID", secondary: "+62", id: 98 },
  IE: { primary: "IE", secondary: "+353", id: 99 },
  IL: { primary: "IL", secondary: "+972", id: 100 },
  IM: { primary: "IM", secondary: "+44", id: 101 },
  IN: { primary: "IN", secondary: "+91", id: 102 },
  IO: { primary: "IO", secondary: "+246", id: 103 },
  IQ: { primary: "IQ", secondary: "+964", id: 104 },
  IR: { primary: "IR", secondary: "+98", id: 105 },
  IS: { primary: "IS", secondary: "+354", id: 106 },
  IT: { primary: "IT", secondary: "+39", id: 107 },
  JE: { primary: "JE", secondary: "+44-1534", id: 108 },
  JM: { primary: "JM", secondary: "+1-876", id: 109 },
  JO: { primary: "JO", secondary: "+962", id: 110 },
  JP: { primary: "JP", secondary: "+81", id: 111 },
  KE: { primary: "KE", secondary: "+254", id: 112 },
  KG: { primary: "KG", secondary: "+996", id: 113 },
  KH: { primary: "KH", secondary: "+855", id: 114 },
  KI: { primary: "KI", secondary: "+686", id: 115 },
  KM: { primary: "KM", secondary: "+269", id: 116 },
  KN: { primary: "KN", secondary: "+1-869", id: 117 },
  KP: { primary: "KP", secondary: "+850", id: 118 },
  KR: { primary: "KR", secondary: "+82", id: 119 },
  KW: { primary: "KW", secondary: "+965", id: 120 },
  KY: { primary: "KY", secondary: "+1-345", id: 121 },
  KZ: { primary: "KZ", secondary: "+7", id: 122 },
  LA: { id: 123, primary: "LA", secondary: "+856" },
  LB: { id: 124, primary: "LB", secondary: "+961" },
  LC: { id: 125, primary: "LC", secondary: "+1758" },
  LI: { id: 126, primary: "LI", secondary: "+423" },
  LK: { id: 127, primary: "LK", secondary: "+94" },
  LR: { id: 128, primary: "LR", secondary: "+231" },
  LS: { id: 129, primary: "LS", secondary: "+266" },
  LT: { id: 130, primary: "LT", secondary: "+370" },
  LU: { id: 131, primary: "LU", secondary: "+352" },
  LV: { id: 132, primary: "LV", secondary: "+371" },
  LY: { id: 133, primary: "LY", secondary: "+218" },
  MA: { id: 134, primary: "MA", secondary: "+212" },
  MC: { id: 135, primary: "MC", secondary: "+377" },
  MD: { id: 136, primary: "MD", secondary: "+373" },
  ME: { id: 137, primary: "ME", secondary: "+382" },
  MF: { id: 138, primary: "MF", secondary: "+590" },
  MG: { id: 139, primary: "MG", secondary: "+261" },
  MH: { id: 140, primary: "MH", secondary: "+692" },
  MK: { id: 141, primary: "MK", secondary: "+389" },
  ML: { id: 142, primary: "ML", secondary: "+223" },
  MM: { id: 143, primary: "MM", secondary: "+95" },
  MN: { id: 144, primary: "MN", secondary: "+976" },
  MO: { id: 145, primary: "MO", secondary: "+853" },
  MP: { id: 146, primary: "MP", secondary: "+1670" },
  MQ: { id: 147, primary: "MQ", secondary: "+596" },
  MR: { id: 148, primary: "MR", secondary: "+222" },
  MS: { id: 149, primary: "MS", secondary: "+1-664" },
  MT: { id: 150, primary: "MT", secondary: "+356" },
  MU: { id: 151, primary: "MU", secondary: "+230" },
  MV: { id: 152, primary: "MV", secondary: "+960" },
  MW: { id: 153, primary: "MW", secondary: "+265" },
  MX: { id: 154, primary: "MX", secondary: "+52" },
  MY: { id: 155, primary: "MY", secondary: "+60" },
  MZ: { id: 156, primary: "MZ", secondary: "+258" },
  NA: { id: 157, primary: "NA", secondary: "+264" },
  NC: { id: 158, primary: "NC", secondary: "+687" },
  NE: { id: 159, primary: "NE", secondary: "+227" },
  NF: { id: 160, primary: "NF", secondary: "+672" },
  NG: { id: 161, primary: "NG", secondary: "+234" },
  NI: { id: 162, primary: "NI", secondary: "+505" },
  NL: { id: 163, primary: "NL", secondary: "+31" },
  NO: { id: 164, primary: "NO", secondary: "+47" },
  NP: { id: 165, primary: "NP", secondary: "+977" },
  NR: { id: 166, primary: "NR", secondary: "+674" },
  NU: { id: 167, primary: "NU", secondary: "+683" },
  NZ: { id: 168, primary: "NZ", secondary: "+64" },
  OM: { id: 169, primary: "OM", secondary: "+968" },
  PA: { id: 170, primary: "PA", secondary: "+507" },
  PE: { id: 171, primary: "PE", secondary: "+51" },
  PF: { id: 172, primary: "PF", secondary: "+689" },
  PG: { id: 173, primary: "PG", secondary: "+675" },
  PH: { id: 174, primary: "PH", secondary: "+63" },
  PK: { id: 175, primary: "PK", secondary: "+92" },
  PL: { id: 176, primary: "PL", secondary: "+48" },
  PM: { id: 177, primary: "PM", secondary: "+508" },
  PN: { id: 178, primary: "PN", secondary: "+64" },
  PR: { id: 179, primary: "PR", secondary: "+1-787" },
  PS: { id: 180, primary: "PS", secondary: "+970" },
  PT: { id: 181, primary: "PT", secondary: "+351" },
  PW: { id: 182, primary: "PW", secondary: "+680" },
  PY: { id: 183, primary: "PY", secondary: "+595" },
  QA: { id: 184, primary: "QA", secondary: "+974" },
  RE: { id: 185, primary: "RE", secondary: "+262" },
  RO: { id: 186, primary: "RO", secondary: "+40" },
  RS: { id: 187, primary: "RS", secondary: "+381" },
  RU: { id: 188, primary: "RU", secondary: "+7" },
  RW: { id: 189, primary: "RW", secondary: "+250" },
  SA: { primary: "SA", secondary: "+966", id: 190 },
  SB: { primary: "SB", secondary: "+677", id: 191 },
  SC: { primary: "SC", secondary: "+248", id: 192 },
  SD: { primary: "SD", secondary: "+249", id: 193 },
  SE: { primary: "SE", secondary: "+46", id: 194 },
  SG: { primary: "SG", secondary: "+65", id: 195 },
  SH: { primary: "SH", secondary: "+290", id: 196 },
  SI: { primary: "SI", secondary: "+386", id: 197 },
  SJ: { primary: "SJ", secondary: "+47", id: 198 },
  SK: { primary: "SK", secondary: "+421", id: 199 },
  SL: { primary: "SL", secondary: "+232", id: 200 },
  SM: { primary: "SM", secondary: "+378", id: 201 },
  SN: { primary: "SN", secondary: "+221", id: 202 },
  SO: { primary: "SO", secondary: "+252", id: 203 },
  SR: { primary: "SR", secondary: "+597", id: 204 },
  SS: { primary: "SS", secondary: "+211", id: 205 },
  ST: { primary: "ST", secondary: "+239", id: 206 },
  SV: { primary: "SV", secondary: "+503", id: 207 },
  SX: { primary: "SX", secondary: "+599", id: 208 },
  SY: { primary: "SY", secondary: "+963", id: 209 },
  SZ: { primary: "SZ", secondary: "+268", id: 210 },
  TC: { primary: "TC", secondary: "+1649", id: 211 },
  TD: { primary: "TD", secondary: "+235", id: 212 },
  TF: { primary: "TF", secondary: "", id: 213 },
  TG: { primary: "TG", secondary: "+228", id: 214 },
  TH: { primary: "TH", secondary: "+66", id: 215 },
  TJ: { primary: "TJ", secondary: "+992", id: 216 },
  TK: { primary: "TK", secondary: "+690", id: 217 },
  TL: { primary: "TL", secondary: "+670", id: 218 },
  TM: { primary: "TM", secondary: "+993", id: 219 },
  TN: { primary: "TN", secondary: "+216", id: 220 },
  TO: { primary: "TO", secondary: "+676", id: 221 },
  TR: { primary: "TR", secondary: "+90", id: 222 },
  TT: { primary: "TT", secondary: "+1868", id: 223 },
  TV: { primary: "TV", secondary: "+688", id: 224 },
  TW: { primary: "TW", secondary: "+886", id: 225 },
  TZ: { primary: "TZ", secondary: "+255", id: 226 },
  UA: { primary: "UA", secondary: "+380", id: 227 },
  UG: { primary: "UG", secondary: "+256", id: 228 },
  UM: { primary: "UM", secondary: "", id: 229 },
  US: { primary: "US", secondary: "+1", id: 230 },
  UY: { primary: "UY", secondary: "+598", id: 231 },
  UZ: { primary: "UZ", secondary: "+998", id: 232 },
  VA: { primary: "VA", secondary: "+379", id: 233 },
  VC: { primary: "VC", secondary: "+1784", id: 234 },
  VE: { primary: "VE", secondary: "+58", id: 235 },
  VG: { primary: "VG", secondary: "+1284", id: 236 },
  VI: { primary: "VI", secondary: "+1340", id: 237 },
  VN: { primary: "VN", secondary: "+84", id: 238 },
  VU: { primary: "VU", secondary: "+678", id: 239 },
  WF: { primary: "WF", secondary: "+681", id: 240 },
  WS: { primary: "WS", secondary: "+685", id: 241 },
  YE: { primary: "YE", secondary: "+967", id: 242 },
  YT: { primary: "YT", secondary: "+262", id: 243 },
  ZA: { primary: "ZA", secondary: "+27", id: 244 },
  ZM: { primary: "ZM", secondary: "+260", id: 245 },
  ZW: { primary: "ZW", secondary: "+263", id: 246 },
};

export const countryNameforPhoneNumber = {
  AF: {
    id: 1,
    primary: "AF",
    secondary: "+93",
  },
  AL: {
    id: 2,
    primary: "AL",
    secondary: "+1-264",
  },
  DZ: {
    id: 3,
    primary: "DZ",
    secondary: "+213",
  },
  AS: {
    id: 4,
    primary: "AS",
    secondary: "+1",
  },
  AD: {
    id: 5,
    primary: "AD",
    secondary: "+376",
  },
  AO: {
    id: 6,
    primary: "AO",
    secondary: "+244",
  },
  AI: {
    id: 7,
    primary: "AI",
    secondary: "+1-264",
  },
  AG: {
    id: 8,
    primary: "AG",
    secondary: "+1-268",
  },
  AR: {
    id: 9,
    primary: "AR",
    secondary: "+54",
  },
  AM: {
    id: 10,
    primary: "AM",
    secondary: "+374",
  },
  AW: {
    id: 11,
    primary: "AW",
    secondary: "+297",
  },
  AU: {
    id: 12,
    primary: "AU",
    secondary: "+61",
  },
  AT: {
    id: 13,
    primary: "AT",
    secondary: "+43",
  },
  AZ: {
    id: 14,
    primary: "AZ",
    secondary: "+994",
  },
  BS: {
    id: 15,
    primary: "BS",
    secondary: "+1",
  },
  BH: {
    id: 16,
    primary: "BH",
    secondary: "+973",
  },
  BD: {
    id: 17,
    primary: "BD",
    secondary: "+880",
  },
  BB: {
    id: 18,
    primary: "BB",
    secondary: "+1",
  },
  BY: {
    id: 19,
    primary: "BY",
    secondary: "+375",
  },
  BE: {
    id: 20,
    primary: "BE",
    secondary: "+32",
  },
  BZ: {
    id: 21,
    primary: "BZ",
    secondary: "+501",
  },
  BJ: {
    id: 22,
    primary: "BJ",
    secondary: "+229",
  },
  BM: {
    id: 23,
    primary: "BM",
    secondary: "+1",
  },
  BT: {
    id: 24,
    primary: "BT",
    secondary: "+975",
  },
  BO: {
    id: 25,
    primary: "BO",
    secondary: "+591",
  },
  BA: {
    id: 26,
    primary: "BA",
    secondary: "+387",
  },
  BW: {
    id: 27,
    primary: "BW",
    secondary: "+267",
  },
  BR: {
    id: 28,
    primary: "BR",
    secondary: "+55",
  },
  IO: {
    id: 29,
    primary: "IO",
    secondary: "+246",
  },
  BG: {
    id: 30,
    primary: "BG",
    secondary: "+359",
  },
  BF: {
    id: 31,
    primary: "BF",
    secondary: "+226",
  },
  BI: {
    id: 32,
    primary: "BI",
    secondary: "+257",
  },
  KH: {
    id: 33,
    primary: "KH",
    secondary: "+855",
  },
  CM: {
    id: 34,
    primary: "CM",
    secondary: "+237",
  },
  CA: {
    id: 35,
    primary: "CA",
    secondary: "+1",
  },
  CV: {
    id: 36,
    primary: "CV",
    secondary: "+238",
  },
  KY: {
    id: 37,
    primary: "KY",
    secondary: "+1-345",
  },
  CF: {
    id: 38,
    primary: "CF",
    secondary: "+236",
  },
  TD: {
    id: 39,
    primary: "TD",
    secondary: "+235",
  },
  CL: {
    id: 40,
    primary: "CL",
    secondary: "+56",
  },
  CN: {
    id: 41,
    primary: "CN",
    secondary: "+86",
  },
  CO: {
    id: 42,
    primary: "CO",
    secondary: "+57",
  },
  KM: {
    id: 43,
    primary: "KM",
    secondary: "+269",
  },
  CG: {
    id: 44,
    primary: "CG",
    secondary: "+242",
  },
  CD: {
    id: 45,
    primary: "CD",
    secondary: "+243",
  },
  CK: {
    id: 46,
    primary: "CK",
    secondary: "+682",
  },
  CR: {
    id: 47,
    primary: "CR",
    secondary: "+506",
  },
  CI: {
    id: 48,
    primary: "CI",
    secondary: "+225",
  },
  HR: {
    id: 49,
    primary: "HR",
    secondary: "+385",
  },
  CU: {
    id: 50,
    primary: "CU",
    secondary: "+53",
  },
  CW: {
    id: 51,
    primary: "CW",
    secondary: "+599",
  },
  CY: {
    id: 52,
    primary: "CY",
    secondary: "+357",
  },
  CZ: {
    id: 53,
    primary: "CZ",
    secondary: "+420",
  },
  DK: {
    id: 54,
    primary: "DK",
    secondary: "+45",
  },
  DJ: {
    id: 55,
    primary: "DJ",
    secondary: "+253",
  },
  DM: {
    id: 56,
    primary: "DM",
    secondary: "+1",
  },
  DO: {
    id: 57,
    primary: "DO",
    secondary: "+1",
  },
  EC: {
    id: 58,
    primary: "EC",
    secondary: "+593",
  },
  EG: {
    id: 59,
    primary: "EG",
    secondary: "+20",
  },
  SV: {
    id: 60,
    primary: "SV",
    secondary: "+503",
  },
  GQ: {
    id: 61,
    primary: "GQ",
    secondary: "+240",
  },
  ER: {
    id: 62,
    primary: "ER",
    secondary: "+291",
  },
  EE: {
    id: 63,
    primary: "EE",
    secondary: "+372",
  },
  ET: {
    id: 64,
    primary: "ET",
    secondary: "+251",
  },
  FK: {
    id: 65,
    primary: "FK",
    secondary: "+500",
  },
  FO: {
    id: 66,
    primary: "FO",
    secondary: "+298",
  },
  FJ: {
    id: 67,
    primary: "FJ",
    secondary: "+679",
  },
  FI: {
    id: 68,
    primary: "FI",
    secondary: "+358",
  },
  FR: {
    id: 69,
    primary: "FR",
    secondary: "+33",
  },
  PF: {
    id: 70,
    primary: "PF",
    secondary: "+689",
  },
  GA: {
    id: 71,
    primary: "GA",
    secondary: "+241",
  },
  GM: {
    id: 72,
    primary: "GM",
    secondary: "+220",
  },
  GE: {
    id: 73,
    primary: "GE",
    secondary: "+995",
  },
  DE: {
    id: 74,
    primary: "DE",
    secondary: "+49",
  },
  GH: {
    id: 75,
    primary: "GH",
    secondary: "+233",
  },
  GI: {
    id: 76,
    primary: "GI",
    secondary: "+350",
  },
  GR: {
    id: 77,
    primary: "GR",
    secondary: "+30",
  },
  GL: {
    id: 78,
    primary: "GL",
    secondary: "+299",
  },
  GD: {
    id: 79,
    primary: "GD",
    secondary: "+1473",
  },
  GU: {
    id: 80,
    primary: "GU",
    secondary: "+1-671",
  },
  GT: {
    id: 81,
    primary: "GT",
    secondary: "+502",
  },
  GG: {
    id: 82,
    primary: "GG",
    secondary: "+44",
  },
  GN: {
    id: 83,
    primary: "GN",
    secondary: "+224",
  },
  GW: {
    id: 84,
    primary: "GW",
    secondary: "+245",
  },
  HT: {
    id: 85,
    primary: "HT",
    secondary: "+509",
  },
  HN: {
    id: 86,
    primary: "HN",
    secondary: "+504",
  },
  HK: {
    id: 87,
    primary: "HK",
    secondary: "+852",
  },
  HU: {
    id: 88,
    primary: "HU",
    secondary: "+36",
  },
  IS: {
    id: 89,
    primary: "IS",
    secondary: "+354",
  },
  IN: {
    id: 90,
    primary: "IN",
    secondary: "+91",
  },
  ER: {
    id: 91,
    primary: "ER",
    secondary: "+62",
  },
  IR: {
    id: 92,
    primary: "IR",
    secondary: "+98",
  },
  IQ: {
    id: 93,
    primary: "IQ",
    secondary: "+964",
  },
  IE: {
    id: 94,
    primary: "IE",
    secondary: "+353",
  },
  IM: {
    id: 95,
    primary: "IM",
    secondary: "+44",
  },
  IL: {
    id: 96,
    primary: "IL",
    secondary: "+972",
  },
  IT: {
    id: 97,
    primary: "IT",
    secondary: "+39",
  },
  JM: {
    id: 98,
    primary: "JM",
    secondary: "+1-876",
  },
  JP: {
    id: 99,
    primary: "JP",
    secondary: "+81",
  },
  JE: {
    id: 100,
    primary: "JE",
    secondary: "+44-1534",
  },
  JO: {
    id: 101,
    primary: "JO",
    secondary: "+962",
  },
  KZ: {
    id: 102,
    primary: "KZ",
    secondary: "+7",
  },
  KE: {
    id: 103,
    primary: "KE",
    secondary: "+254",
  },
  KI: {
    id: 104,
    primary: "KI",
    secondary: "+686",
  },
  KP: {
    id: 105,
    primary: "KP",
    secondary: "+850",
  },
  KR: {
    id: 106,
    primary: "KR",
    secondary: "+82",
  },
  KW: {
    id: 107,
    primary: "KW",
    secondary: "+965",
  },
  KG: {
    id: 108,
    primary: "KG",
    secondary: "+996",
  },
  LA: {
    id: 109,
    primary: "LA",
    secondary: "+856",
  },
  LV: {
    id: 110,
    primary: "LV",
    secondary: "+371",
  },
  LB: {
    id: 111,
    primary: "LB",
    secondary: "+961",
  },
  LS: {
    id: 112,
    primary: "LS",
    secondary: "+266",
  },
  LR: {
    id: 113,
    primary: "LR",
    secondary: "+231",
  },
  LY: {
    id: 114,
    primary: "LY",
    secondary: "+218",
  },
  LI: {
    id: 115,
    primary: "LI",
    secondary: "+423",
  },
  LT: {
    id: 116,
    primary: "LT",
    secondary: "+370",
  },
  LU: {
    id: 117,
    primary: "LU",
    secondary: "+352",
  },
  MO: {
    id: 118,
    primary: "MO",
    secondary: "+853",
  },
  MK: {
    id: 119,
    primary: "MK",
    secondary: "+389",
  },
  MG: {
    id: 120,
    primary: "MG",
    secondary: "+261",
  },
  MW: {
    id: 121,
    primary: "MW",
    secondary: "+265",
  },
  MY: {
    id: 122,
    primary: "MY",
    secondary: "+60",
  },
  MV: {
    id: 123,
    primary: "MV",
    secondary: "+960",
  },
  ML: {
    id: 124,
    primary: "ML",
    secondary: "+223",
  },
  MT: {
    id: 125,
    primary: "MT",
    secondary: "+356",
  },
  MH: {
    id: 126,
    primary: "MH",
    secondary: "+692",
  },
  MQ: {
    id: 127,
    primary: "MQ",
    secondary: "+596",
  },
  MR: {
    id: 128,
    primary: "MR",
    secondary: "+222",
  },
  MU: {
    id: 129,
    primary: "MU",
    secondary: "+230",
  },
  MX: {
    id: 130,
    primary: "MX",
    secondary: "+52",
  },
  FM: {
    id: 131,
    primary: "FM",
    secondary: "+691",
  },
  MD: {
    id: 132,
    primary: "MD",
    secondary: "+373",
  },
  MC: {
    id: 133,
    primary: "MC",
    secondary: "+377",
  },
  MN: {
    id: 134,
    primary: "MN",
    secondary: "+976",
  },
  ME: {
    id: 135,
    primary: "ME",
    secondary: "+382",
  },
  MS: {
    id: 136,
    primary: "MS",
    secondary: "+1-664",
  },
  MA: {
    id: 137,
    primary: "MA",
    secondary: "+212",
  },
  MZ: {
    id: 138,
    primary: "MZ",
    secondary: "+258",
  },
  MM: {
    id: 139,
    primary: "MM",
    secondary: "+95",
  },
  NA: {
    id: 140,
    primary: "NA",
    secondary: "+264",
  },
  NR: {
    id: 141,
    primary: "NR",
    secondary: "+674",
  },
  NP: {
    id: 142,
    primary: "NP",
    secondary: "+977",
  },
  NL: {
    id: 143,
    primary: "NL",
    secondary: "+31",
  },
  NZ: {
    id: 144,
    primary: "NZ",
    secondary: "+64",
  },
  NI: {
    id: 145,
    primary: "NI",
    secondary: "+505",
  },
  NE: {
    id: 146,
    primary: "NE",
    secondary: "+227",
  },
  NG: {
    id: 147,
    primary: "NG",
    secondary: "+234",
  },
  NU: {
    id: 148,
    primary: "NU",
    secondary: "+683",
  },
  NF: {
    id: 149,
    primary: "NF",
    secondary: "+672",
  },
  MP: {
    id: 150,
    primary: "MP",
    secondary: "+1670",
  },
  NO: {
    id: 151,
    primary: "NO",
    secondary: "+47",
  },
  OM: {
    id: 152,
    primary: "OM",
    secondary: "+968",
  },
  PK: {
    id: 153,
    primary: "PK",
    secondary: "+92",
  },
  PW: {
    id: 154,
    primary: "PW",
    secondary: "+680",
  },
  PS: {
    id: 155,
    primary: "PS",
    secondary: "+970",
  },
  PA: {
    id: 156,
    primary: "PA",
    secondary: "+507",
  },
  PG: {
    id: 157,
    primary: "PG",
    secondary: "+507",
  },
  PY: {
    id: 158,
    primary: "PY",
    secondary: "+595",
  },
  PE: {
    id: 159,
    primary: "PE",
    secondary: "+51",
  },
  PH: {
    id: 160,
    primary: "PH",
    secondary: "+63",
  },
  PN: {
    id: 161,
    primary: "PN",
    secondary: "+64",
  },
  PL: {
    id: 162,
    primary: "PL",
    secondary: "+48",
  },
  PT: {
    id: 163,
    primary: "PT",
    secondary: "+351",
  },
  PR: {
    id: 164,
    primary: "PR",
    secondary: "+1-787",
  },
  QA: {
    id: 165,
    primary: "QA",
    secondary: "+974",
  },
  RO: {
    id: 166,
    primary: "RO",
    secondary: "+40",
  },
  RU: {
    id: 167,
    primary: "RU",
    secondary: "+7",
  },
  RW: {
    id: 168,
    primary: "RW",
    secondary: "+250",
  },
  KN: {
    id: 169,
    primary: "KN",
    secondary: "+1-869",
  },
  LC: {
    id: 170,
    primary: "LC",
    secondary: "+1758",
  },
  WS: {
    id: 171,
    primary: "WS",
    secondary: "+685",
  },
  SM: {
    id: 172,
    primary: "SM",
    secondary: "+378",
  },
  ST: {
    id: 173,
    primary: "ST",
    secondary: "+239",
  },
  SA: {
    id: 174,
    primary: "SA",
    secondary: "+966",
  },
  SN: {
    id: 175,
    primary: "SN",
    secondary: "+221",
  },
  RS: {
    id: 176,
    primary: "RS",
    secondary: "+381",
  },
  SC: {
    id: 177,
    primary: "SC",
    secondary: "+248",
  },
  SL: {
    id: 178,
    primary: "SL",
    secondary: "+232",
  },
  SG: {
    id: 179,
    primary: "SG",
    secondary: "+65",
  },
  SX: {
    id: 180,
    primary: "SX",
    secondary: "+599",
  },
  SK: {
    id: 181,
    primary: "SK",
    secondary: "+421",
  },
  SI: {
    id: 182,
    primary: "SI",
    secondary: "+386",
  },
  SB: {
    id: 183,
    primary: "SB",
    secondary: "+677",
  },
  SO: {
    id: 184,
    primary: "SO",
    secondary: "+252",
  },
  ZA: {
    id: 185,
    primary: "ZA",
    secondary: "+27",
  },
  SS: {
    id: 186,
    primary: "SS",
    secondary: "+211",
  },
  ES: {
    id: 187,
    primary: "ES",
    secondary: "+34",
  },
  LK: {
    id: 188,
    primary: "LK",
    secondary: "+94",
  },
  SD: {
    id: 189,
    primary: "SD",
    secondary: "+249",
  },
  SR: {
    id: 190,
    primary: "SR",
    secondary: "+597",
  },
  SZ: {
    id: 191,
    primary: "SZ",
    secondary: "+268",
  },
  SE: {
    id: 192,
    primary: "SE",
    secondary: "+46",
  },
  CH: {
    id: 193,
    primary: "CH",
    secondary: "+41",
  },
  SY: {
    id: 194,
    primary: "SY",
    secondary: "+963",
  },
  TW: {
    id: 195,
    primary: "TW",
    secondary: "+886",
  },
  TJ: {
    id: 196,
    primary: "TJ",
    secondary: "+992",
  },
  TZ: {
    id: 197,
    primary: "TZ",
    secondary: "+255",
  },
  TH: {
    id: 198,
    primary: "TH",
    secondary: "+66",
  },
  TG: {
    id: 199,
    primary: "TG",
    secondary: "+228",
  },
  TK: {
    id: 200,
    primary: "TK",
    secondary: "+690",
  },
  TO: {
    id: 201,
    primary: "TO",
    secondary: "+676",
  },
  TT: {
    id: 202,
    primary: "TT",
    secondary: "+1868",
  },
  TN: {
    id: 203,
    primary: "TN",
    secondary: "+216",
  },
  TR: {
    id: 204,
    primary: "TR",
    secondary: "+90",
  },
  TM: {
    id: 205,
    primary: "TM",
    secondary: "+993",
  },
  TC: {
    id: 206,
    primary: "TC",
    secondary: "+1649",
  },
  TV: {
    id: 207,
    primary: "TV",
    secondary: "+688",
  },
  UG: {
    id: 208,
    primary: "UG",
    secondary: "+256",
  },
  UA: {
    id: 209,
    primary: "UA",
    secondary: "+380",
  },
  AE: {
    id: 210,
    primary: "AE",
    secondary: "+971",
  },
  GB: {
    id: 211,
    primary: "GB",
    secondary: "+44",
  },
  US: {
    id: 212,
    primary: "US",
    secondary: "+1",
  },
  UY: {
    id: 213,
    primary: "UY",
    secondary: "+598",
  },
  UZ: {
    id: 214,
    primary: "UZ",
    secondary: "+998",
  },
  VU: {
    id: 215,
    primary: "VU",
    secondary: "+678",
  },
  VE: {
    id: 216,
    primary: "VE",
    secondary: "+58",
  },
  VN: {
    id: 217,
    primary: "VN",
    secondary: "+84",
  },
  VI: {
    id: 218,
    primary: "VI",
    secondary: "+1340",
  },
  YE: {
    id: 219,
    primary: "YE",
    secondary: "+967",
  },
  ZM: {
    id: 220,
    primary: "ZM",
    secondary: "+260",
  },
  ZW: {
    id: 221,
    primary: "ZW",
    secondary: "+263",
  },
};
